import React from 'react';
import { useGoodsOptionsBrief } from '../../queries/useGoodsOptionsBrief';
import {
  formatNumber,
  isNil,
  isNotNil,
  localizeNumber,
} from 'shared/src/utils';
import { Flex, Typography } from '@banhala/ui-kit';
import { useGoodsPromotionComponents } from '../../../../queries/useGoodsPromotionComponents';
import { BrandIconFreeDelivery } from '../BrandIconFreeDelivery';

const SelectOptionsBottomBannerContent: React.FC = () => {
  const { data: goodsOptionsBrief } = useGoodsOptionsBrief();
  const { data: promotions } =
    useGoodsPromotionComponents('GOODS_OPTION_MODAL');

  if (isNil(goodsOptionsBrief)) return null;

  if (goodsOptionsBrief.minimum_order_amount > 0) {
    return (
      <Flex.Center padding={{ vertical: 10 }} backgroundColor={'blue5'}>
        {isNotNil(goodsOptionsBrief.minimum_order_required_category) ? (
          <Typography color={'content_slate_primary'} type={'body3'}>
            이 마켓의 {goodsOptionsBrief.minimum_order_required_category.name}{' '}
            최소 주문 금액{' '}
            <Typography color={'content_slate_primary'} type={'subtitle3'}>
              {localizeNumber(goodsOptionsBrief.minimum_order_amount)}원
            </Typography>
          </Typography>
        ) : (
          <Typography color={'content_slate_primary'} type={'body3'}>
            이 마켓에서{' '}
            <Typography color={'content_slate_primary'} type={'subtitle3'}>
              {formatNumber(goodsOptionsBrief.minimum_order_amount).value}원
              이상 담을 시
            </Typography>{' '}
            주문 가능
          </Typography>
        )}
      </Flex.Center>
    );
  }

  if (
    isNotNil(promotions.component) &&
    promotions.component.banners.length > 0
  ) {
    return (
      <Flex>
        {promotions.component.banners.map(banner => (
          <Flex.Row
            alignItems={'center'}
            justifyContent={'center'}
            padding={{ vertical: 10 }}
            backgroundColorValue={banner.item.background_color}
            gap={4}
          >
            <Typography rawColor={banner.item.text_color}>
              {banner.item.text}
            </Typography>
          </Flex.Row>
        ))}
      </Flex>
    );
  }

  return (
    <Flex.Row
      alignItems={'center'}
      justifyContent={'center'}
      padding={{ vertical: 10 }}
      backgroundColorValue={'#FFF6EB'}
      gap={4}
    >
      <Typography>하나만 사도</Typography>
      <BrandIconFreeDelivery />
    </Flex.Row>
  );
};
export const SelectOptionsBottomBanner: React.FC = () => {
  return (
    <React.Suspense fallback={<></>}>
      <SelectOptionsBottomBannerContent />
    </React.Suspense>
  );
};
